// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rw-0";